<template>
  <div class="animated fadeIn">
    <b-card header-tag="header">
      <div slot="header">
        <i class="icon-screen-smartphone"></i> Credenciamento
      </div>

      <!-- Erro geral -->
      <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>

      <!-- Carregando -->
      <div v-if="loading" class="text-center py-4">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
      </div>

      <div v-if="enrollment">
        <!-- Dados do credenciamento -->
        <b-card class="mb-3" bg-variant="light">
          <div class="form-row">
            <div class="col-md-4">
              <div class="form-group mb-0">
                <label class="text-muted small">Código de Ativação</label>
                <p class="font-weight-bold">{{ enrollment.activationCode }}</p>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mb-0">
                <label class="text-muted small">Serial Number</label>
                <p class="font-weight-bold">{{ enrollment.serialNumber || '—' }}</p>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group mb-0">
                <label class="text-muted small">Tipo</label>
                <p class="font-weight-bold">{{ bindKindName(enrollment.kind) || '—' }}</p>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group mb-0">
                <label class="text-muted small">Status</label>
                <p class="font-weight-bold">{{ bindStatusName(enrollment.status) }}</p>
              </div>
            </div>
          </div>
        </b-card>

        <!-- Inativação: spinner enquanto carrega seller -->
        <div v-if="isInactivation && !selectedSeller" class="text-center py-3">
          <i class="fa fa-spinner fa-spin"></i>
        </div>

        <!-- Ativação: seleção de empresa -->
        <div v-if="!isInactivation" class="form-row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Empresa <span class="text-danger">*</span></label>
              <model-list-select
                :list="sellers.data"
                option-value="id"
                option-text="name"
                v-model="form.sellerId"
                placeholder="Digite o nome da empresa para buscar"
                @searchchange="searchSellers"
              ></model-list-select>
              <small v-if="sellerError" class="text-danger">{{ sellerError }}</small>
            </div>
          </div>
        </div>

        <!-- Dados do seller — aparece nos dois fluxos -->
        <b-card v-if="selectedSeller" class="mb-3" bg-variant="light">
          <h6 class="mb-3">{{ isInactivation ? 'Dados da empresa a inativar' : 'Confirme os dados da empresa' }}</h6>
          <div class="form-row">
            <div class="col-md-4">
              <label class="text-muted small">Razão Social</label>
              <p class="font-weight-bold">{{ selectedSeller.name || '—' }}</p>
            </div>
            <div class="col-md-4">
              <label class="text-muted small">Nome Fantasia</label>
              <p class="font-weight-bold">{{ selectedSeller.socialName || '—' }}</p>
            </div>
            <div class="col-md-4">
              <label class="text-muted small">CNPJ / CPF</label>
              <p class="font-weight-bold">{{ selectedSeller.documentNumber || '—' }}</p>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-4">
              <label class="text-muted small">E-mail</label>
              <p class="font-weight-bold">{{ selectedSeller.email || '—' }}</p>
            </div>
            <div class="col-md-4">
              <label class="text-muted small">Telefone</label>
              <p class="font-weight-bold">
                {{ selectedSeller.phone ? `(${selectedSeller.phone.areaCode}) ${selectedSeller.phone.number}` : '—' }}
              </p>
            </div>
            <div class="col-md-4">
              <label class="text-muted small">Status</label>
              <p class="font-weight-bold">{{ selectedSeller.status || '—' }}</p>
            </div>
          </div>
        </b-card>

        <!-- Ações -->
        <div class="mt-3">
          <b-button :variant="isInactivation ? 'danger' : 'primary'" :disabled="saving || (!isInactivation && !form.sellerId)" @click="approve">
            <i v-if="saving" class="fa fa-spinner fa-spin"></i>
            <i v-else :class="isInactivation ? 'fa fa-ban' : 'fa fa-check'"></i>
            {{ saving ? 'Salvando...' : (isInactivation ? 'Inativar terminal' : 'Ativar terminal') }}
          </b-button>
          <b-button variant="secondary" class="ml-2" :disabled="saving" @click="cancel">
            Cancelar
          </b-button>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import enrollmentService from '../../../services/Devices/enrollmentService';
import sellerService from '../../../services/Customer/sellerService';
import { ModelListSelect } from 'vue-search-select';
import config from '../../../config';

export default {
  components: { ModelListSelect },

  data() {
    return {
      activationCode: null,
      enrollment: null,
      loading: false,
      saving: false,
      errorMessage: null,
      sellerError: null,
      sellers: { data: [] },
      selectedSeller: null,
      form: {
        sellerId: null,
      },
    };
  },

  created() {
    this.activationCode = this.$route.query.code;
    if (!this.activationCode) {
      this.errorMessage = 'Código de ativação não informado. Volte e escaneie o QR Code novamente.';
      return;
    }
    this.fetchEnrollment();
  },

  computed: {
    isInactivation() {
      return this.enrollment && this.enrollment.kind === 'INACTIVATION';
    },
  },

  watch: {
    'form.sellerId'(id) {
      if (!id) { this.selectedSeller = null; return; }
      sellerService.find(id).then(
        (response) => { this.selectedSeller = response.data; },
        () => { this.selectedSeller = null; }
      );
    },
  },

  methods: {
    fetchEnrollment() {
      this.loading = true;
      this.errorMessage = null;
      enrollmentService.findByActivationCode(this.activationCode).then(
        (response) => {
          this.enrollment = response.data;
          this.loading = false;
          if (this.enrollment.kind === 'INACTIVATION' && this.enrollment.sellerId) {
            sellerService.find(this.enrollment.sellerId).then(
              (r) => { this.selectedSeller = r.data; },
              () => {}
            );
          }
        },
        () => {
          this.errorMessage = 'Não foi possível carregar os dados do credenciamento. Verifique o código e tente novamente.';
          this.loading = false;
        }
      );
    },

    searchSellers(query) {
      if (!query || query.length < 2) return;
      this.showLoading && this.showLoading();
      sellerService.all(query).then(
        (response) => {
          this.sellers.data = response.status === 204 ? [] : response.data;
        },
        () => {}
      );
    },

    approve() {
      this.sellerError = null;

      const sellerId = this.isInactivation ? this.enrollment.sellerId : this.form.sellerId;

      if (!this.isInactivation && !sellerId) {
        this.sellerError = 'Selecione uma empresa para ativar o terminal.';
        return;
      }

      const sellerName = this.isInactivation
        ? this.enrollment.sellerName
        : (this.selectedSeller && this.selectedSeller.name);

      const action = this.isInactivation ? 'inativar' : 'ativar';

      this.$bvModal.msgBoxConfirm(
        `Você tem certeza que quer ${action} o estabelecimento "${sellerName}"?`,
        {
          title: 'Confirmar',
          okTitle: this.isInactivation ? 'Inativar' : 'Ativar',
          okVariant: this.isInactivation ? 'danger' : 'primary',
          cancelTitle: 'Cancelar',
          centered: true,
        }
      ).then((confirmed) => {
        if (!confirmed) return;

        this.saving = true;
        const payload = {
          sellerId,
          ignoreWarnings: false,
          partnerKey: this.$auth.partnerKey,
        };

        enrollmentService.approve(this.activationCode, payload).then(
          () => {
            this.$router.push('/partners/enrollments');
          },
          (error) => {
            const msg = error.response && error.response.data && error.response.data.message;
            this.errorMessage = msg || 'Ocorreu um erro ao aprovar o credenciamento.';
            this.saving = false;
          }
        );
      });
    },

    cancel() {
      this.$router.push('/partners/enrollments');
    },

    bindStatusName(status) {
      return enrollmentService.getStatusName(status);
    },
    bindKindName(kind) {
      return enrollmentService.getKindName(kind);
    },
  }    
};
</script>
